import { createEvent } from 'effector';

export const updateDistrictsEv = createEvent();

export const resetDistrictsLayerPolygonsFilteredEv = createEvent();

export const updateDistrictsByOverviewEv = createEvent();
